import Utils from '@/utils/default'

export default {
  color (color) {
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`
  },
  colorValue (colorItem) {
    const element = document.createElement('div')
    element.setAttribute('class', colorItem)
    document.body.appendChild(element)
    const color = window.getComputedStyle(element).backgroundColor
    document.body.removeChild(element)
    const array = color.replace('rgb(', '').replace(')', '').split(', ')
    return {
      r: parseInt(array[0], 10),
      g: parseInt(array[1], 10),
      b: parseInt(array[2], 10),
      a: parseInt(array[3], 10) || 1
    }
  },
  createLinearGradient (component, colors) {
    const gradient = component.$refs.canvas.getContext('2d')
      .createLinearGradient(0, 0, 0, component.$el.offsetHeight)
    colors.forEach((color, i) => {
      gradient.addColorStop(i / (colors.length - 1), color)
    })
    return gradient
  },
  label (value, length = 20) {
    if (value.trim().length < length) {
      return value
    } else {
      return value.trim().substr(0, length - 3).trim() + '...'
    }
  },
  datasetIdentifier (dataKey, params) {
    return dataKey + Utils.dataToUrlString({ ...params })
  }
}



// WEBPACK FOOTER //
// ./src/utils/charts.js